'use client'

import React from 'react'
import { HeroParticles } from './HeroParticles'

export interface GlobalBackgroundProps {
  className?: string
  variant?: 'default' | 'hero' | 'minimal'
  height?: string | number
}

const ResponsiveBackgroundSVG: React.FC = () => {
  const [background, setBackground] = React.useState<string | null>(null)

  React.useEffect(() => {
    function updateBackground() {
      const width = window.innerWidth
      if (width < 768) {
        setBackground('/iPhone 16 - 1.svg')
      } else if (width < 1200) {
        setBackground('/iPad Pro 12.9_ - 1.svg')
      } else {
        setBackground('/Desktop - 1.svg')
      }
    }
    updateBackground()
    window.addEventListener('resize', updateBackground)
    return () => window.removeEventListener('resize', updateBackground)
  }, [])

  if (!background) return null
  return (
    <img
      src={background}
      alt="Background"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: 0,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    />
  )
}

export const GlobalBackground: React.FC<GlobalBackgroundProps> = ({
  className = '',
  variant = 'default',
  height = '100vh',
}) => {
  const getHeightStyle = () => {
    if (typeof height === 'string') {
      return { height }
    }
    return { height: `${height}px` }
  }

  return (
    <div className={`fixed inset-0 pointer-events-none z-0 ${className}`} style={getHeightStyle()}>
      {/* Responsive SVG background based on client width */}
      <ResponsiveBackgroundSVG />

      {/* Interactive particles for hero sections */}
      {variant === 'hero' && (
        <div className="absolute inset-0" style={{ height: '200vh' }}>
          <HeroParticles className="absolute inset-0" density={400} variant="network" fullHeight />
        </div>
      )}

      {/* Additional gradient overlay for depth */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-strandforge-purple/5 via-transparent to-strandforge-purple-dark/5"
        style={{
          background: `
            radial-gradient(circle at 20% 30%, rgba(126, 52, 220, 0.08) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(159, 91, 240, 0.06) 0%, transparent 50%),
            radial-gradient(circle at 40% 90%, rgba(100, 37, 176, 0.07) 0%, transparent 50%)
          `,
        }}
      />
    </div>
  )
}
